export default class CreateRenewalViewModel {
    public id: string | null = null;
    public accountId = 0;
    public salesPerson = '';
    public packageId = '';
    public agreementId = '';
    public renewalDate = '';
    public priceOffered: number = 0;
    public startDate: Date = new Date();
} 